import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'

import { getLanguages } from 'utils/languages'
import { EMAIL_FIELD, LANGUAGE_FIELD, NAME_FIELD, PHONE_FIELD } from './model'

// the server reports validation errors per field, as { email: ['...'] }
const fieldError = (formState, name) =>
  formState.errors.root?.apiError?.message?.[name]?.[0] ??
  formState.errors[name]?.message

export const CandidateForm = ({ control, formState, languages }) => (
  <Form>
    <Form.Field
      error={fieldError(formState, NAME_FIELD)}
      label={t`Name`}
      field="input"
      name={NAME_FIELD}
      {...{ control }}
    />
    <Form.Field
      error={fieldError(formState, EMAIL_FIELD)}
      label={t`Email`}
      field="input"
      name={EMAIL_FIELD}
      type="email"
      {...{ control }}
    />
    <Form.Field
      error={formState.errors[LANGUAGE_FIELD]?.message}
      label={t`Language`}
      field="combobox"
      name={LANGUAGE_FIELD}
      options={getLanguages().filter(language =>
        languages.includes(language.value),
      )}
      isClearable
      {...{ control }}
    />
    <Form.Field
      error={fieldError(formState, PHONE_FIELD)}
      label={t`Phone number`}
      field="input"
      hint={t`Use format as follows: +[country code] [number]`}
      name={PHONE_FIELD}
      type="tel"
      isOptional
      {...{ control }}
    />
  </Form>
)
